import { IconButton } from "ui/icon-button/icon-button";
import { ACTION_BUTTON_SX } from "ui/alert/alert.styles";
import { CLOSE_GLYPH, CLOSE_LABEL, TOGGLE_GLYPH, TOGGLE_LABEL } from "ui/alert/alert.constants";

import Icons from "assets";

type AlertCloseButtonProps = { onClose: () => void };

export const AlertCloseButton = ({ onClose }: AlertCloseButtonProps) => (
  <IconButton
    aria-label={CLOSE_LABEL}
    variant="text"
    color="inherit"
    size="small"
    onClick={onClose}
    sx={ACTION_BUTTON_SX}>
    <Icons.Close width={CLOSE_GLYPH} height={CLOSE_GLYPH} />
  </IconButton>
);

type AlertToggleButtonProps = {
  isExpanded: boolean;
  bodyId: string;
  onToggle: () => void;
};

export const AlertToggleButton = ({ isExpanded, bodyId, onToggle }: AlertToggleButtonProps) => {
  const Chevron = isExpanded ? Icons.ChevronDown : Icons.ChevronRight;

  return (
    <IconButton
      aria-label={TOGGLE_LABEL}
      aria-expanded={isExpanded}
      aria-controls={bodyId}
      variant="text"
      color="inherit"
      size="small"
      onClick={onToggle}
      sx={ACTION_BUTTON_SX}>
      <Chevron width={TOGGLE_GLYPH} height={TOGGLE_GLYPH} />
    </IconButton>
  );
};
